import React from "react";
import { useSpecialFunctions } from "../../functions";
import Rights from "../../constants/Rights";

const TicketsInfoTable = ({
  ticketInfo,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  userRightsList,
}) => {
  const { getTimeInfo } = useSpecialFunctions();

  const hasSelectAllPermissions = () =>
    userRightsList.some((right) =>
      [Rights.FRM_VOID_TICKET, Rights.FRM_SCORE_TICKETS].includes(
        right.FormName,
      ),
    );
  // Headers
  let headers,
    tableInfoTickets = [];
  headers = (
    <tr className="text-center">
      <th hidden>IDTicket</th>
      <th>Ticket #</th>
      <th>Account</th>
      <th>Placed</th>
      <th>Status</th>
      <th>Description</th>
      <th>Stake</th>
      <th>Paid</th>
    </tr>
  );

  // Tickets OnChange
  const ticketsChangeHandler = (ticketID) => {
    if (!hasSelectAllPermissions()) {
      return;
    }

    if (selectedTicketsVoidScore.includes(ticketID)) {
      // If the id is already in the list, it deletes it.
      setSelectedTicketsVoidScore(
        selectedTicketsVoidScore.filter((item) => item !== ticketID),
      );
    } else {
      // If the id is not in the list, it adds it.
      setSelectedTicketsVoidScore([...selectedTicketsVoidScore, ticketID]);
    }
  };

  // The main Ticket Information table
  if (ticketInfo.length !== 0) {
    let ticketStatus;
    tableInfoTickets = ticketInfo.PastPostList.map((item, i) => {
      ticketStatus = "";

      if (item.TicketStatus === 2 && item.VoidReason === 0) {
        ticketStatus = "Scored";
      } else if (item.TicketStatus === 2 && item.VoidReason !== 0) {
        ticketStatus = "Void";
      } else {
        ticketStatus = "Open";
      }

      const isOpen = ticketStatus === "Open";

      return (
        <React.Fragment key={i}>
          <tr
            key={item.TicketID}
            style={{
              cursor:
                hasSelectAllPermissions() && isOpen ? "pointer" : "not-allowed",
              opacity: isOpen ? 1 : 0.5,
            }}
            onClick={() => {
              if (!hasSelectAllPermissions() || !isOpen) return;
              ticketsChangeHandler(item.TicketID);
            }}
            className={
              isOpen && selectedTicketsVoidScore.includes(item.TicketID)
                ? "shadedRow"
                : ""
            }
          >
            <td key={"TicketID" + i} className="d-none">
              {item.TicketID}
            </td>
            {/* Ticket# */}
            <td
              key={"TicketNum" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TicketID}
            </td>
            {/* Account */}
            <td
              key={"Account" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.AccountUserName}
            </td>
            {/* Placed */}
            <td
              key={"Placed" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {getTimeInfo(item.PlacedDateTime)}
            </td>
            {/* Status */}
            <td
              key={"Status" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {ticketStatus}
            </td>

            {/* TicketDesc */}
            <td
              key={"TicketDesc" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TicketDesc} {item.Selections}
            </td>
            {/* TotalStake */}
            <td
              key={"TotalStake" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.TotalStake}
            </td>
            {/* WinPaid */}
            <td
              key={"WinPaid" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {item.WinPaid}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  const handleSelectAll = () => {
    const allTicketIDs = ticketInfo.PastPostList.map((item) => item.TicketID);

    if (selectAllTickets) {
      setSelectedTicketsVoidScore([]);
    } else {
      setSelectedTicketsVoidScore(allTicketIDs);
    }

    setSelectAllTickets(!selectAllTickets);
  };

  return (
    <div
      style={{
        overflow: "auto",
      }}
      className="tablesPastPost"
    >
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="exampleCheck1"
          checked={selectAllTickets}
          onChange={handleSelectAll}
          disabled={!hasSelectAllPermissions() || ticketInfo?.length === 0}
        />
        <label
          className="form-check-label"
          htmlFor="exampleCheck1"
          style={{ color: "#8c8c8c", fontSize: "16px" }}
        >
          Select All Tickets
        </label>
      </div>
      <table className="table table-hover table-sm mt-1">
        <thead style={{ position: "sticky", top: "0", background: "#d9d9d9" }}>
          {headers}
        </thead>
        <tbody className="table-lg">{tableInfoTickets}</tbody>
      </table>
    </div>
  );
};

export default TicketsInfoTable;
